export default __webpack_public_path__ + "static/media/id-jb.b8799aa3.svg";